import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e319e6f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel, useDebounceFn } from '@vueuse/core';
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { updateGm, saveGm } from '@/api/gm.js';
export default {
  __name: 'Gm',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // 表单数据
    const formData = ref({
      name: '',
      // 应用名称
      appId: '',
      // 应用id
      appSecret: '',
      // 应用密钥
      publicKey: '',
      // 应用公钥
      privateKey: '',
      // 应用私钥
      remark: '' // 备注
    });
    const resetForm = () => {
      formData.value = {
        name: '',
        // 应用名称
        appId: '',
        // 应用id
        appSecret: '',
        // 应用密钥
        publicKey: '',
        // 应用公钥
        privateKey: '',
        // 应用私钥
        remark: '' // 备注
      };
    };
    watch(() => props.model, val => {
      if (val) {
        formData.value = {
          id: val.id,
          ...JSON.parse(JSON.stringify(val))
        };
      } else {
        resetForm();
      }
    }, {
      deep: true,
      immediate: true
    });
    const emits = __emit;
    const isVisible = useVModel(props);
    const rules = ref({
      name: [{
        required: true,
        message: '应用名称不能为空',
        trigger: 'blur'
      }],
      appId: [{
        required: true,
        message: '应用id不能为空',
        trigger: 'blur'
      }],
      appSecret: [{
        required: true,
        message: '应用密钥不能为空',
        trigger: 'blur'
      }],
      publicKey: [{
        required: true,
        message: '应用公钥不能为空',
        trigger: 'blur'
      }],
      privateKey: [{
        required: true,
        message: '应用私钥不能为空',
        trigger: 'blur'
      }]
    });

    // 表单元素
    const formEl = ref(null);
    /**
     * 新增事件
     */
    const addNewsGmHandler = useDebounceFn(async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          try {
            if (!props.model) {
              await saveGm(formData.value);
            } else {
              await updateGm(formData.value);
            }
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
          } catch (error) {
            console.log(error);
          } finally {
            isVisible.value = false;
          }
        }
      });
    }, 300);
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改应用' : '新增应用',
        width: "50%",
        onClosed: closed,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(addNewsGmHandler)
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["onClick"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          rules: rules.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "应用名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.name = $event),
              placeholder: "请输入应用名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "应用id",
            prop: "appId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.appId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.appId = $event),
              placeholder: "请输入应用id"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "应用密钥",
            prop: "appSecret"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: {
                minRows: 5
              },
              modelValue: formData.value.appSecret,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.appSecret = $event),
              placeholder: "请输入应用密钥"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "应用公钥",
            prop: "publicKey"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: {
                minRows: 5
              },
              modelValue: formData.value.publicKey,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.publicKey = $event),
              placeholder: "请输入应用公钥"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "应用私钥",
            prop: "privateKey"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: {
                minRows: 5
              },
              modelValue: formData.value.privateKey,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.privateKey = $event),
              placeholder: "请输入应用私钥"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: {
                minRows: 5
              },
              modelValue: formData.value.remark,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.remark = $event),
              placeholder: "请输入备注"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};